<div class="field">
    <div class="flex-row">
        <!-- Avatar -->
        <div *ngIf="!parent.profile.ImageUrl" class="partner-profile-avatar-empty">
            {{parent.profile.FirstName | slice:0:1 | uppercase}}{{parent.profile.LastName | slice:0:1 | uppercase}}
        </div>
        <div *ngIf="parent.profile.ImageUrl">
            <img class="partner-profile-avatar" src="{{parent.profile.ImageUrl}}" />
        </div>
        <!-- Upload button -->
        <div style="padding: 10px 0 0 10px;">
            <input id="idImgInput" type="file" accept="image/*" style="display: none"
                   (change)="parent.handleImageChange($event)" />

            <button pButton type="button" label="Upload" class="p-button-text" icon="pi pi-upload"
                    (click)="parent.handleUploadClick()"></button>
        </div>
    </div>
</div>

<div class="field">
    <div>First Name:</div>
    <input pInputText [(ngModel)]="parent.profile.FirstName" />
</div>
<div class="field">
    <div>Last Name:</div>
    <input pInputText [(ngModel)]="parent.profile.LastName" />
</div>
<div class="field">
    <div>Phone:</div>
    <input pInputText [(ngModel)]="parent.profile.Phone" />
</div>
<div class="field">
    <div>Email:</div>
    <input pInputText [(ngModel)]="parent.profile.Email" />
</div>

<hr style="margin-left: -1rem; margin-right: -1rem;" />

<p>Only administrators can update the below settings</p>

<div class="field">
    <div>Role:</div>
    <p-dropdown [options]="parent.roles"
                [(ngModel)]="parent.profile.RoleId"
                [optionLabel]="'Name'"
                [optionValue]="'Id'"
                [appendTo]="'body'"
                [disabled]="parent.appData.xpressUserRoleId!==xpressUserRoleEnum.Admin">
    </p-dropdown>
</div>

<div class="field">
    <div>Home Office:</div>
    <p-dropdown [options]="parent.locations"
                [(ngModel)]="parent.profile.LocationId"
                [optionLabel]="'Name'"
                [optionValue]="'Id'"
                [appendTo]="'body'"
                [disabled]="parent.appData.xpressUserRoleId!==xpressUserRoleEnum.Admin">
    </p-dropdown>
</div>
